import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ThermostatIcon from "@mui/icons-material/Thermostat";

const Temperature1Widget = ({ widget, onValueUpdate }) => {
  const [temperature, setTemperature] = useState(0);
  const [unit, setUnit] = useState("C");
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const valueStr = widget.items.$w1.value;
      const numericValue = parseFloat(valueStr.replace(/[^0-9.-]/g, ""));
      const targetUnit = widget.items.$w1.unit || "C";
      setUnit(targetUnit);

      // Convert to target unit if needed
      let convertedTemp = numericValue;
      if (valueStr.toUpperCase().includes("F") && targetUnit === "C") {
        // Convert F to C
        convertedTemp = ((numericValue - 32) * 5) / 9;
      } else if (valueStr.toUpperCase().includes("C") && targetUnit === "F") {
        // Convert C to F
        convertedTemp = (numericValue * 9) / 5 + 32;
      }

      setTemperature(convertedTemp);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
        width: "100%",
        padding: 2,
        backgroundColor: isFlashing ? "secondary.main" : "background.default",
        borderRadius: 2,
        transition: "background-color 0.5s ease",
      }}
    >
      <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
        {temperature.toFixed(1)} °{unit}
      </Typography>
      <ThermostatIcon
        sx={{
          fontSize: "1.2rem",
          color: "#FFB74D",
        }}
      />
    </Box>
  );
};

export default Temperature1Widget;
